import { getSidebarCustomize } from "../sidebar/getSidebarCustomize.js";
/**
 * Check if the current window is the preview iframe.
 */ function isPreviewScreen() {
    return !getSidebarCustomize(false).panel;
}
export { isPreviewScreen };
